import React from "react";
import Controls from "src/components/form/controls/Controls";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import { CACHE_HOME_INDEX } from "src/constants/actionCache";
import ShowCacheFLFHomeIndex from "../ShowCache/ShowCacheFLFHomeIndex";
import FLFHomeIndexPopup from "../Popup/FLFHomeIndexPopup";

const FLFHomeIndexControlPanel = ({
  children,
  isSorted,
  handleSort,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Home Index"
          isShowButton={isShowCache(currentActionCache, CACHE_HOME_INDEX)}
        >
          <ShowCacheFLFHomeIndex
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>
        {isSorted ? (
          <Controls.Button
            text="Apply sort"
            variant="outlined"
            onClick={handleSort}
          />
        ) : null}
        <FLFHomeIndexPopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default FLFHomeIndexControlPanel;
